import { useAccessContext } from "@contexts/access/hooks";

export const useUserInfo = () => useAccessContext().userInfo;
